import { connect } from 'react-redux';

import NormalInvoicesPresentation from './NormalInvoicesPresentation';

import { invoicesActions } from 'dataflow/billingPortal/actions';

function mapStateToProps(state) {
    const { userPermissions } = state.userManagementReducers;

	return {
        ...state.invoicesReducers,
        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getInvoiceList: (pageNo, pageSize, sort, filterOptions) => { dispatch(invoicesActions.getInvoiceList(pageNo, pageSize, sort, filterOptions)); },

        deleteInvoice: (invoiceId) => { dispatch(invoicesActions.deleteInvoice(invoiceId)); },
        postToSQLAccount: (invoiceId) => { dispatch(invoicesActions.postToSQLAccount(invoiceId)); },
        sendEmail: (invoiceId, isSentToCustomers) => { dispatch(invoicesActions.sendEmail(invoiceId, isSentToCustomers)); },
    };
}

const NormalInvoices = connect(mapStateToProps, mapDispatchToProps)(NormalInvoicesPresentation);

export default NormalInvoices;